import React, { useCallback, useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate, useParams } from 'react-router-dom';
import { head, isEmpty, isNil, pathOr } from 'ramda';

// store
import { storeSet, useStoreValue } from '../../../../store';

// components
import ButtonFlat from '../../../../components/ButtonWrapper/components/ButtonFlat';
import DropdownWithSearch from '../../../../components/DropdownWithSearch';
import MovieIcon from '../../../../icons/MovieIcon';
import UserTopBarMenu from './components/UserTopBarMenu';
import UserStatusTopBar from './components/UserStatusTopBar';
import ProjectTopBar from './components/ProjectTopBar';
import TopBarLeftControls from './components/TopBarLeftControls';
import ModalCreateProject from '../../../../components/ModalCreateProject';
import CaretLeftIcon from '../../../../icons/CaretLeftIcon';
import ButtonIconSimple from '../../../../components/ButtonWrapper/components/ButtonIconSimple';

const AppTopbar = () => {
    const navigate = useNavigate();
    const { projectId } = useParams();
    const projects = useStoreValue('projects');
    const projectVideos = useStoreValue('projectVideos');
    const selectedVideo = useStoreValue('selectedVideo');
    const hasStudioInUrl = window.location.href.indexOf('/studio') !== -1;
    const isProjects = window.location.href.indexOf('/projects') !== -1 && (isNil(projectId) || isEmpty(projectId)) && !hasStudioInUrl;
    const isProject = projectId && window.location.href.indexOf('/projects') !== -1 && !hasStudioInUrl;
    const isMystudio = projectId && hasStudioInUrl;
    const isProfile = window.location.href.indexOf('/profile') !== -1;
    const videoOptions = projectVideos.map(video => ({ value: video.id, label: video.name }));
    const [data, setData] = useState({});

    const handleProjectSelection = (id) => {
        storeSet('selectedVideo', '');
        navigate(`/projects/${id}`);
    }

    const handleBackToProject = () => {
        navigate(`/projects/${projectId}`);
    }

    const handleBackToProjects = () => {
        storeSet('selectedVideo', '');
        navigate('/projects');
    }

    const handleOpenDashboard = () => {
        navigate(`/projects`);
    }

    const handleOpenProjectInMyStudio = useCallback(() => {
        navigate(`/projects/${projectId}/studio`);
    }, [projectId]);

    const handleSelectVideo = (value) => {
        storeSet('selectedVideo', value)
    }

    useEffect(() => {
        if (projectId && !isEmpty(projectId)) {
            const project = pathOr({}, [], head(projects.filter(o => o.id === projectId)));
            setData(project);

            storeSet('fetchVideos', projectId);
        }
    }, [projectId, projects]);

    useEffect(() => {
        // Fetch projects via React Query action
        storeSet('fetchProjects');
    }, []);

    return (
        <div className="topBar">
            <div className="topBar__row">
                <TopBarLeftControls/>
                {!isEmpty(projectId) && !isNil(projectId)
                    ? <ProjectTopBar/>
                    : <UserStatusTopBar/>}
                <UserTopBarMenu/>
            </div>
            <div className="topBar__row">
                <div>
                    {!isEmpty(projectId) && !isNil(projectId)
                        ? isMystudio || isProfile
                            ? <ButtonIconSimple onClick={handleBackToProject} additionalClasses={['topBarBackBtn']}>
                                <CaretLeftIcon/>
                            </ButtonIconSimple>
                            : <ButtonIconSimple onClick={handleBackToProjects} additionalClasses={['topBarBackBtn']}>
                                <CaretLeftIcon/>
                            </ButtonIconSimple>
                        : null}
                </div>
                {isMystudio
                    ? <div className="actions">
                        <DropdownWithSearch
                            value={selectedVideo}
                            selectFn={handleSelectVideo}
                            options={videoOptions}>
                            <MovieIcon/>
                        </DropdownWithSearch>
                        {/*<DropdownWithSearch
                            value={projectId}
                            selectFn={() => {
                            }}
                            options={[
                                { value: 1, label: '1' },
                                { value: 2, label: '2' },
                                { value: 3, label: '3' }
                            ]}>
                            <VideoIcon/>
                        </DropdownWithSearch>*/}
                        {/*<ButtonFlat
                            onClick={() => {
                            }}>
                            {__('Preview', 'soundbetween')}
                        </ButtonFlat>*/}
                    </div>
                    : null}
                {isProjects || isProject
                    ? <div className="actions">
                        <DropdownWithSearch
                            emptyLabel={__('Nessun risultato', 'soundbetween')}
                            placeholder={__('Cambia progetto', 'soundbetween')}
                            nonChosenLabel={__('Cambia progetto', 'soundbetween')}
                            value={projectId}
                            displayNonChosenLabel={true}
                            selectFn={handleProjectSelection}
                            options={projects.filter(o => !o.archived).map(o => ({ value: o.id, label: o.title }))}/>
                        <ModalCreateProject type="topbar"/>
                        {projectId
                            ? <ButtonFlat
                                onClick={handleOpenProjectInMyStudio}>
                                {__('Apri in My Studio', 'soundbetween')}
                            </ButtonFlat> : null}
                    </div> : null}
                {isProfile
                    ? <div className="actions">
                        <ButtonFlat
                            onClick={handleOpenDashboard}>
                            {__('Dashboard', 'soundbetween')}
                        </ButtonFlat>
                        <ButtonFlat
                            onClick={handleBackToProjects}>
                            {__('Projects', 'soundbetween')}
                        </ButtonFlat>
                    </div> : null}
                <div>
                </div>
            </div>
        </div>
    )
}

export default AppTopbar;
